/**
 * Theme module — light/dark switcher con persistencia en localStorage.
 */

const THEME_KEY = "kt-theme";
type ThemeMode = "light" | "dark";

export function getTheme(): ThemeMode {
  return (localStorage.getItem(THEME_KEY) as ThemeMode) || "light";
}

export function applyTheme(mode: ThemeMode): void {
  localStorage.setItem(THEME_KEY, mode);
  const html = document.documentElement;
  html.setAttribute("data-kt-theme-mode", mode);
  html.classList.remove("light", "dark");
  html.classList.add(mode);

  // Actualizar icono del botón si existe
  const icon = document.getElementById("theme-icon");
  if (icon) {
    if (mode === "dark") {
      icon.className = "ki-filled ki-moon text-lg";
    } else {
      icon.className = "ki-filled ki-sun text-lg";
    }
  }
}

export function toggleTheme(): void {
  const current = getTheme();
  applyTheme(current === "light" ? "dark" : "light");
}

export function initTheme(): void {
  applyTheme(getTheme());
}
